import { TRoadblockChecklistItemType } from "../codecs/form/RoadblockForm";
import { TChecklistItemResolvedByParty } from "../codecs/ChecklistItemResolvedByParty";

export type { TChecklistItemResolvedByParty };

export const checklistItemResolvedByParty: Record<TRoadblockChecklistItemType, TChecklistItemResolvedByParty> = {
    test_checklist_item_1: "conveyancer",
    test_checklist_item_2: "conveyancer",
    test_checklist_item_3: "conveyancer",
    test_checklist_item_4: "conveyancer",
    test_checklist_item_5: "conveyancer",
    test_checklist_item_6: "conveyancer",

    quote_created: "conveyancer",
    quote_sent: "conveyancer",
    draft_contract_created: "conveyancer",
    draft_tr1_created: "conveyancer",
    draft_as1_created: "conveyancer",
    draft_contract_sent: "conveyancer",
    os_conveyancer_details_added: "conveyancer",
    verify_os_conveyancer: "conveyancer",
    property_details_added: "conveyancer",
    contract_details_added: "conveyancer",
    estate_agent_details_added: "conveyancer",
    add_completion_deadline_for_auction_case: "conveyancer",
    add_os_client_details: "conveyancer",
    case_instructed: "conveyancer",
    offer_accepted: "third_party",

    client_id_checks_passed: "client",
    client_video_calls_passed: "client",
    client_no_vulnerability_concerns_on_call: "client",
    email_phone_validation_check_completed: "client",
    terms_of_engagement_agreed: "client",
    consent_to_dual_rep: "client",
    bank_accounts_verified: "client",
    purchase_payment_method_set: "client",
    all_clients_added_and_right_to_buy_or_sell_checked: "conveyancer",
    ongoing_risk_assessment_completed: "conveyancer",
    peps_resolved: "conveyancer",
    peps_holp_signoff: "conveyancer",
    potential_fraud_reviewed: "conveyancer",
    conflicts_of_interest_reviewed: "conveyancer",
    failed_video_calls_reviewed: "conveyancer",
    money_on_account_received: "client",
    source_of_wealth_satisfied: "client",
    transfer_ownership_status_set_for_all_clients: "conveyancer",
    auction_reservation_fee_answered: "conveyancer", // REVIEW: client may need to confirm the fee
    auction_pack_sent: "conveyancer",
    gift_declaration_signed: "client",

    all_title_checks_complete: "conveyancer",
    reason_for_transaction_set: "conveyancer",
    all_documents_referred_to_in_titles_obtained: "conveyancer",
    unregistered_deeds_obtained: "client",
    epc_received: "conveyancer", // REVIEW: seller-provided, sometimes via agent
    arrange_new_epc: "conveyancer", // we arrange a replacement EPC when the client asked us to
    lpe1_ordered: "conveyancer",
    lpe1_received_for_all_leasehold_titles: "third_party",
    fme1_received: "third_party",
    ast_received: "client", // REVIEW: tenancy doc, seller-provided
    grant_of_probate_received: "third_party",
    ta6_received: "client",
    ta7_received: "client",
    ta10_received: "client",
    pif_received: "client",
    local_authority_search_received: "third_party",
    environment_search_received: "third_party",
    drainage_search_received: "third_party",
    searches_required_check_complete: "conveyancer",
    searches_required_answered: "conveyancer",
    searches_ordered: "conveyancer",
    oes_ordered: "conveyancer",
    management_company_details_obtained: "third_party",
    management_company_consent_obtained: "third_party",
    account_numbers_received_for_all_charges: "third_party",
    first_redemption_statement_received: "conveyancer",

    all_enquiries_resolved_or_not_relevant: "conveyancer",
    undertakings_approved_or_marked_none: "conveyancer",
    risk_grade_green_and_recent: "conveyancer",
    recent_last_transfer_risk_assessed: "conveyancer",
    all_charges_and_title_restrictions_marked_added: "conveyancer",
    search_report_uploaded: "conveyancer",
    leasehold_report_uploaded: "conveyancer",
    enquiries_report_uploaded: "conveyancer",
    mortgage_report_uploaded: "conveyancer",
    mortgage_lender_identified: "conveyancer",
    mortgage_offer_added: "conveyancer", // REVIEW: lender issues; client sometimes forwards
    mortgage_offer_questions_answered: "conveyancer",
    mortgage_offer_not_expired: "conveyancer",
    mortgage_retention_shared_with_client: "conveyancer",
    early_repayment_charge_obtained: "conveyancer",
    client_notified_of_early_repayment_charge: "conveyancer",
    bank_accounts_verified_or_marked_unused: "conveyancer",
    sdlt_return_uploaded_or_compass_referral_set: "conveyancer",
    sdlt_declaration_signed_by_all_clients: "client",
    sdlt_added_to_ledger: "conveyancer",
    clients_authorised_exchange_and_complete: "client",
    joint_ownership_held_as_answered: "client",
    charges_have_account_numbers: "conveyancer",
    apportionment_question_answered: "conveyancer",
    dual_rep_lender_conflict_approved_if_required: "conveyancer",
    dual_rep_missing_consent_obtained: "client", // REVIEW: we obtain it, but the consent is the client's
    leasehold_fee_added_to_ledger: "conveyancer",
    land_registry_fee_added_to_ledger: "conveyancer",
    electronic_transfer_fee_added_to_ledger: "conveyancer",
    estate_agent_fee_added_to_ledger: "conveyancer",
    deposit_added_to_ledger: "conveyancer",
    draft_completion_statement_uploaded: "conveyancer",
    bankruptcy_search_complete: "conveyancer",
    title_report_uploaded: "conveyancer",
    survey_status_answered: "client",
    report_sent: "conveyancer",
    ready_for_exchange_review_complete: "conveyancer",

    funds_requested_from_lender: "conveyancer",
    funds_received_from_lender: "third_party",
    funds_requested_from_client: "conveyancer",
    funds_received_from_client: "client",
    redemption_statement_for_completion_received: "third_party",
    seller_solicitor_paid: "conveyancer",
    seller_solicitor_payment_confirmed: "third_party",
    seller_conveyancer_bank_account_verified: "conveyancer",
    proceeds_of_sale_received_from_buyer_solicitor: "third_party",

    registration_signed_transfer_received: "conveyancer",
    registration_signed_charge_received: "conveyancer",
    registration_submitted: "conveyancer",
    requisitions_resolved: "conveyancer",
    cancellation_resolved: "conveyancer",
    registration_complete: "conveyancer",
    case_ledger_finalised: "conveyancer",
    payments_due_chased: "conveyancer",
    slip_added_to_cashroom: "conveyancer",
    ledger_items_paid_out: "conveyancer",
    sail_legal_invoice_paid: "conveyancer",
    post_forwarded_or_shredded: "conveyancer",
    referral_fee_paid: "conveyancer",
    retention_settled: "conveyancer",

    buildings_insurance_received: "client",

    divorce_document_type_selected: "conveyancer",
    divorce_document_received: "third_party",
    departing_owners_ila_or_disclaimer_complete: "client",

    grant_applied_for: "third_party", // REVIEW: applicant is the PR/executor, sometimes via us
    will_received: "third_party",
    death_certificate_received: "third_party",
    probate_grant_matched_on_hmcts: "conveyancer",

    signed_contract_received: "client",
    signed_tr1_received: "client",
    signed_as1_received: "client",
    signed_mortgage_deed_received: "client",
    signed_occupier_consent_received: "client",

    ad_hoc: "conveyancer",
};

export const getChecklistItemResolvedByParty = (
    type: TRoadblockChecklistItemType,
): TChecklistItemResolvedByParty =>
    checklistItemResolvedByParty[type] ?? "conveyancer";
